var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _rect, _path5, _path6, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse3, _path16, _path17, _path18, _path19, _path20, _rect3, _path21, _circle, _circle2, _circle3, _circle4, _circle5, _path22, _path23, _path24, _path25, _path26, _path27, _rect4, _path28, _path29, _ellipse4, _path30, _path31, _g, _path32, _circle6, _circle7, _circle8, _ellipse5, _path33, _ellipse6, _ellipse7, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodingLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 107,
    viewBox: "0 0 181 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.492,
    cy: 3.28295,
    rx: 31.492,
    ry: 3.28295,
    transform: "matrix(-1 0 0 1 169.924 92.168)",
    fill: "#E0E0E0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.9405,
    cy: 8.46007,
    rx: 68.9405,
    ry: 8.46007,
    transform: "matrix(-1 0 0 1 137.881 90.082)",
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.416 61.6465V101.178",
    stroke: "#DA5107",
    strokeWidth: 3.0177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4395 55.9141V95.446",
    stroke: "#DA5107",
    strokeWidth: 3.0177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2812 61.6465V101.178",
    stroke: "#DA5107",
    strokeWidth: 3.0177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.303 55.9141V95.446",
    stroke: "#DA5107",
    strokeWidth: 3.0177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.2871,
    y: 59.5352,
    width: 74.0846,
    height: 6.78983,
    rx: 1.96151,
    fill: "#FFC2A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.498 52.293H128.583L88.3717 59.5355H14.2871L54.498 52.293Z",
    fill: "#FFE9DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8066 61.2045C85.8066 60.2426 86.5042 59.4226 87.4536 59.2684L125.326 53.1158C126.519 52.922 127.602 53.8431 127.602 55.052V57.8674C127.602 58.8293 126.904 59.6492 125.955 59.8035L88.0827 65.956C86.8895 66.1498 85.8066 65.2287 85.8066 64.0199V61.2045Z",
    fill: "#FFC2A2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.6777,
    y: 21.0332,
    width: 26.6284,
    height: 31.2489,
    rx: 0.729545,
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6309 21.7627C95.6309 21.3598 95.9575 21.0332 96.3604 21.0332H103.899C104.302 21.0332 104.629 21.3598 104.629 21.7627V51.5525C104.629 51.9554 104.302 52.2821 103.899 52.2821H96.3604C95.9575 52.2821 95.6309 51.9554 95.6309 51.5525V21.7627Z",
    fill: "#B3B3B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0586 55.6855L48.1506 56.4161V57.3888L38.0586 56.6582V55.6855Z",
    fill: "#B3B3B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1504 56.478L58.9196 54.1055V55.0169L48.1504 57.3895V56.478Z",
    fill: "#B3B3B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1416 53.1211L59.7076 53.9093L48.0895 56.4743L37.5234 55.6861L49.1416 53.1211Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1621 44.9027L45.4446 44.7402V55.604L44.1621 55.2338V44.9027Z",
    fill: "#B3B3B3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3691 44.9026L53.2906 43.9219V54.7856L45.3691 55.7664V44.9026Z",
    fill: "#D9D9D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2543 17.4871C26.2265 16.9687 26.6415 16.5332 27.1606 16.5332C27.6389 16.5332 28.0367 16.9053 28.0662 17.3828L30.0347 49.295C30.0669 49.8159 29.6531 50.256 29.1312 50.256H28.8718C28.3906 50.256 27.9935 49.8797 27.9677 49.3992L26.2543 17.4871Z",
    fill: "#B3B3B3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4653 17.4871C27.4374 16.9687 27.8502 16.5332 28.3693 16.5332H67.7566C68.2341 16.5332 68.6295 16.904 68.6601 17.3805L70.3622 43.9054C70.3927 44.3802 70.0503 44.7976 69.5787 44.8607L30.1961 50.1261C29.6725 50.1961 29.2005 49.8048 29.1721 49.2773L27.4653 17.4871Z",
    fill: "#D9D9D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8243 18.7719C28.7967 18.2522 29.2118 17.8163 29.7322 17.8186L66.8545 17.9776C67.3303 17.9796 67.7233 18.3496 67.754 18.8244L69.2804 42.3977C69.311 42.8716 68.9704 43.2886 68.5 43.3531L31.3837 48.4454C30.8589 48.5174 30.3847 48.1255 30.3566 47.5966L28.8243 18.7719Z",
    fill: "#808080"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 83.7767,
    cy: 36.7223,
    rx: 7.9642,
    ry: 8.025,
    fill: "#B3B3B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7326 28.0344C47.6762 27.8879 47.7415 27.7226 47.8829 27.6543L48.7695 27.2255C48.929 27.1484 49.1203 27.2246 49.183 27.3903L60.2091 56.4863C60.2646 56.6327 60.1989 56.7972 60.0579 56.8652L59.3196 57.2207C59.1607 57.2972 58.9704 57.2218 58.907 57.0573L47.7326 28.0344Z",
    fill: "#B3B3B3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.916 27.2452L72.5295 24.5293L83.7705 53.5747L60.157 56.2906L48.916 27.2452Z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6504 28.469L71.9248 26.0215L82.091 52.2908L60.8166 54.7384L50.6504 28.469Z",
    fill: "#ECF8FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8555 56.3655L84.148 53.5176H109.119L87.7692 56.6673L59.8555 56.3655Z",
    fill: "#E0E0E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4004 55.9315L82.9401 53.7864L94.4073 53.7656L77.8854 55.9315H63.4004Z",
    fill: "#B3B3B3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.3066,
    y: 56.3652,
    width: 27.4611,
    height: 1.20708,
    rx: 0.30177,
    fill: "#B3B3B3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6934 56.6322C87.6934 56.4808 87.8056 56.3528 87.9557 56.333L108.552 53.6211C108.732 53.5973 108.893 53.738 108.893 53.9203V54.5186C108.893 54.67 108.78 54.798 108.63 54.8178L88.0345 57.5297C87.8538 57.5535 87.6934 57.4128 87.6934 57.2305V56.6322Z",
    fill: "#B3B3B3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128.156,
    cy: 100.249,
    r: 1.76307,
    fill: "#DA5107"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.148,
    cy: 95.3881,
    r: 1.76307,
    fill: "#DA5107"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.183,
    cy: 93.2006,
    r: 1.76307,
    fill: "#DA5107"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.747,
    cy: 92.5931,
    r: 1.76307,
    fill: "#DA5107"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.679,
    cy: 97.5756,
    r: 1.76307,
    fill: "#DA5107"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132.595 72.832V93.9281M132.595 93.9281H114.721M132.595 93.9281L127.792 98.7309M132.595 93.9281L150.955 95.8735M132.595 93.9281L142.869 90.9491M132.595 93.9281L127.792 90.9491",
    stroke: "#DA5107",
    strokeWidth: 2.43182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M145.137 16.2224C145.516 14.4218 147.104 13.1328 148.944 13.1328H175.524C177.995 13.1328 179.84 15.4068 179.331 17.8251L168.993 66.9478C168.614 68.7484 167.025 70.0374 165.185 70.0374H138.606C136.134 70.0374 134.289 67.7634 134.798 65.3451L145.137 16.2224Z",
    fill: "#FF7E3B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M140.881 16.2224C141.26 14.4218 142.849 13.1328 144.689 13.1328H171.268C173.739 13.1328 175.585 15.4068 175.076 17.8251L164.737 66.9478C164.358 68.7484 162.769 70.0374 160.929 70.0374H134.35C131.878 70.0374 130.033 67.7634 130.542 65.3451L140.881 16.2224Z",
    fill: "#FF9F6C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M159.407 2.46681C159.993 0.978544 161.429 0 163.028 0H169.833C172.576 0 174.458 2.76228 173.454 5.31501L171.254 10.9082C170.669 12.3965 169.233 13.375 167.633 13.375H160.828C158.085 13.375 156.204 10.6127 157.208 8.05999L159.407 2.46681Z",
    fill: "#FF7E3B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.245 2.46681C155.831 0.978544 157.267 0 158.866 0H165.671C168.414 0 170.296 2.76228 169.292 5.31501L167.092 10.9082C166.507 12.3965 165.07 13.375 163.471 13.375H156.666C153.923 13.375 152.041 10.6127 153.045 8.05999L155.245 2.46681Z",
    fill: "#FF9F6C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M104.629 69.6195C104.629 67.2023 106.81 65.3701 109.191 65.7869L126.761 68.8627C128.622 69.1886 129.981 70.8052 129.981 72.6953V73.9144C129.981 76.3317 127.8 78.1639 125.419 77.7471L107.849 74.6713C105.987 74.3454 104.629 72.7287 104.629 70.8387V69.6195Z",
    fill: "#FF9F6C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124.568,
    y: 69.4277,
    width: 39.1523,
    height: 9.11932,
    rx: 3.89091,
    fill: "#FF7E3B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.199 36.5978C117.206 36.6092 118.013 37.435 118.002 38.4422C117.94 43.8422 113.837 46.9915 109.611 48.7158C105.545 50.3749 100.803 50.9849 97.4859 51.0595L93.1658 53.6627C92.3031 54.1825 91.1822 53.9046 90.6623 53.0418C90.1425 52.179 90.4204 51.0582 91.2832 50.5383L96.0253 47.6809C96.306 47.5118 96.6272 47.4214 96.955 47.4193C99.9906 47.4 104.52 46.8534 108.233 45.3384C111.998 43.8021 114.318 41.5609 114.354 38.4008C114.366 37.3936 115.191 36.5863 116.199 36.5978Z",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.491 71.1816C112.179 66.5995 118.741 63.2285 129.491 63.2285C130.436 63.2285 131.213 63.9468 131.306 64.8671C134.284 64.222 137.711 63.9088 141.641 64.0196C142.648 64.048 143.441 64.8872 143.413 65.8941C143.384 66.901 142.545 67.6943 141.538 67.6659C130.709 67.3605 124.646 70.4928 121.348 74.1782C118.003 77.9153 117.245 82.5021 117.565 85.5308C117.62 86.0461 117.453 86.5604 117.105 86.945L113.154 91.3223C112.479 92.07 111.325 92.1289 110.578 91.4539C109.83 90.7789 109.771 89.6256 110.446 88.8779L113.873 85.0822C113.677 81.2682 114.768 76.0608 118.63 71.7455C120.21 69.98 122.219 68.4025 124.728 67.1392C117.743 67.9568 113.662 70.5741 111.333 73.4685C108.467 77.0295 107.99 81.3295 108.434 84.1637C108.536 84.8145 108.279 85.4698 107.762 85.8779C107.245 86.286 106.548 86.3835 105.939 86.1329L99.4334 83.4579C98.5018 83.0749 98.0572 82.0091 98.4403 81.0775C98.8233 80.1459 99.8891 79.7012 100.821 80.0843L104.653 81.66C104.76 78.4103 105.779 74.5521 108.491 71.1816Z",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.04602,
    cy: 6.26193,
    rx: 5.04602,
    ry: 6.26193,
    transform: "matrix(-1 0 0 1 121.041 15.3184)",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.21591
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M152.535 22.2495C152.535 15.1984 146.819 9.48242 139.768 9.48242H125.664C118.613 9.48242 112.897 15.1984 112.897 22.2495V56.6597C112.897 63.7107 118.613 69.4267 125.664 69.4267H139.768C146.819 69.4267 152.535 63.7107 152.535 56.6597V22.2495Z",
    fill: "#FFC2A2",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_46218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 12,
    width: 42,
    height: 59
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M152.535 25.894C152.535 18.8429 146.819 13.127 139.768 13.127H125.664C118.613 13.127 112.897 18.843 112.897 25.894V56.6565C112.897 63.7076 118.613 69.4235 125.664 69.4235H139.768C146.819 69.4235 152.535 63.7075 152.535 56.6565V25.894Z",
    fill: "#AFE8C2",
    stroke: "#149A53",
    strokeWidth: 1.21591,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_46218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.475 69.4258H112.958",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.475 49.6094H112.958",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.475 62.8613H112.958",
    stroke: "#FF9F6C",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.475 56.1738H112.958",
    stroke: "#FF9F6C",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.475 49.6094H112.958",
    stroke: "#FF9F6C",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.475 43.041H112.958",
    stroke: "#FF9F6C",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.475 36.3574H112.958",
    stroke: "#FF9F6C",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.535 29.8496V69.3666",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.969 36.4746V69.4257",
    stroke: "#FF9F6C",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.281 36.4746V69.4257",
    stroke: "#FF9F6C",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.715 36.4746V69.4257",
    stroke: "#FF9F6C",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.148 36.4746V69.4257",
    stroke: "#FF9F6C",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.463 36.4746V69.4257",
    stroke: "#FF9F6C",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.896 29.8496V69.3666",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.475 69.4219H112.958",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.56591,
    height: 33.0727,
    transform: "matrix(-1 0 0 1 139.281 36.3516)",
    fill: "#FF7E3B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.56591,
    height: 19.6977,
    transform: "matrix(-1 0 0 1 132.717 49.7266)",
    fill: "#FF7E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.15 56.168H119.584V69.2998H126.15V56.168Z",
    fill: "#FF7E3B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.07954,
    height: 19.6977,
    transform: "matrix(-1 0 0 1 119.584 49.7266)",
    fill: "#FF7E3B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.56591,
    height: 13.1318,
    transform: "matrix(-1 0 0 1 145.848 56.293)",
    fill: "#FF7E3B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.07954,
    height: 26.3852,
    transform: "matrix(-1 0 0 1 151.928 43.0352)",
    fill: "#FF7E3B"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M152.535 22.2495C152.535 15.1984 146.819 9.48242 139.768 9.48242H125.664C118.613 9.48242 112.897 15.1984 112.897 22.2495V56.6597C112.897 63.7107 118.613 69.4267 125.664 69.4267H139.768C146.819 69.4267 152.535 63.7107 152.535 56.6597V22.2495Z",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.11655,
    cy: 4.11655,
    r: 4.11655,
    transform: "matrix(-1 0 0 1 136.85 13.373)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.11655,
    cy: 4.11655,
    r: 4.11655,
    transform: "matrix(-1 0 0 1 126.529 13.373)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.94545,
    cy: 1.94545,
    r: 1.94545,
    transform: "matrix(-1 0 0 1 133.322 16.2891)",
    fill: "#9E2F00"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.94545,
    cy: 1.7787,
    rx: 1.94545,
    ry: 1.7787,
    transform: "matrix(-1 0 0 1 122.746 16.5332)",
    fill: "#9E2F00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M112.835 21.575C112.57 18.8461 114.209 16.6301 114.981 14.0241C115.753 11.4181 117.016 9.02698 118.684 7.01179C120.353 4.99661 122.39 3.40413 124.656 2.3416C126.923 1.27908 129.367 0.771178 131.824 0.852102C134.281 0.933027 136.694 1.6009 138.9 2.81074C141.107 4.02059 143.055 5.74431 144.615 7.86583C146.174 9.98735 147.309 12.4574 147.942 15.1097C148.574 17.7619 148.691 20.5348 148.283 23.2415L145.681 22.7527C146.026 20.4612 145.927 18.1137 145.391 15.8683C144.856 13.6229 143.895 11.5317 142.575 9.73565C141.254 7.93956 139.605 6.48026 137.737 5.456C135.869 4.43175 133.826 3.86632 131.746 3.79781C129.666 3.7293 127.597 4.15929 125.678 5.05883C123.759 5.95836 122.035 7.30656 120.622 9.01262C119.209 10.7187 116.345 11.8178 115.692 14.0241C114.226 15.9695 112.597 19.0954 112.821 21.4057L112.835 21.575Z",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.28033
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.04602,
    cy: 6.26193,
    rx: 5.04602,
    ry: 6.26193,
    transform: "matrix(-1 0 0 1 152.777 15.3184)",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.21591
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.89091,
    cy: 4.80284,
    rx: 3.89091,
    ry: 4.80284,
    transform: "matrix(-1 0 0 1 152.777 16.7773)",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.21591
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.47 38.085C146.125 38.8501 146.036 40.0015 145.27 40.6566C137.418 47.3796 126.576 50.2892 116.429 51.2758C106.638 52.2276 97.2522 51.4129 91.2907 50.3124L87.6316 52.5078C86.7679 53.0261 85.6476 52.746 85.1293 51.8823C84.6111 51.0185 84.8912 49.8982 85.7549 49.3799L90.0106 46.8265C90.3982 46.594 90.8583 46.5136 91.3018 46.6011C96.902 47.7053 106.286 48.5969 116.076 47.6452C125.897 46.6903 135.867 43.9054 142.898 37.8857C143.663 37.2306 144.814 37.3198 145.47 38.085Z",
    fill: "#FF7E3B",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M131.926 25.352C134.358 25.657 135.33 25.3526 135.877 25.1094",
    stroke: "#9E2F00",
    strokeWidth: 1.21591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1883 42.7981L62.1453 42.2574L63.4995 44.6541L64.0923 44.3192L62.7381 41.9225L63.6951 41.3817L63.3745 40.8143L60.8677 42.2307L61.1883 42.7981ZM64.8064 43.9157L65.4543 43.5496L65.3366 42.6888L66.5816 41.9854L67.2624 42.528L67.9145 42.1595L65.0329 39.8773L64.33 40.2745L64.8064 43.9157ZM65.2447 41.9922L65.081 40.783L66.0365 41.5448L65.2447 41.9922ZM68.2908 41.9469L68.8836 41.612L68.264 40.5152L69.005 40.0965C69.6063 39.7568 69.7442 39.1705 69.4332 38.62C69.1246 38.0738 68.5469 37.8918 67.9499 38.2292L66.616 38.9828L68.2908 41.9469ZM67.9434 39.9478L67.5294 39.2153L68.2281 38.8205C68.4907 38.6722 68.7088 38.7221 68.8404 38.955C68.9744 39.1921 68.9046 39.4047 68.642 39.5531L67.9434 39.9478Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6304 43.7015L74.7243 43.5938L74.9941 46.3334L75.6717 46.2666L75.4019 43.5271L76.4958 43.4193L76.432 42.7708L73.5665 43.0529L73.6304 43.7015ZM76.488 46.1862L77.2286 46.1133L77.4689 45.2784L78.8919 45.1382L79.2954 45.9098L80.0407 45.8364L78.3276 42.5841L77.5241 42.6632L76.488 46.1862ZM77.6664 44.604L78.0055 43.4319L78.5715 44.5149L77.6664 44.604ZM80.4708 45.794L81.1485 45.7273L81.025 44.4737L81.8721 44.3902C82.5594 44.3226 82.9226 43.8421 82.8606 43.2128C82.7991 42.5884 82.3443 42.1885 81.6618 42.2557L80.1372 42.4059L80.4708 45.794ZM80.9611 43.8251L80.8787 42.9877L81.6773 42.9091C81.9774 42.8795 82.1568 43.0134 82.183 43.2796C82.2097 43.5506 82.0599 43.7169 81.7598 43.7464L80.9611 43.8251Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingLoader);
export default __webpack_public_path__ + "static/media/coding-loader.038add2280f071f1dafec05b3a4e2347.svg";
export { ForwardRef as ReactComponent };